import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';
import { TEMPLATE_CONDITION } from '@doda/common/src/constants/searchConditionModal';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import {
  createSearchConditionName,
  makeSendConditionParam,
} from '@doda/common/src/logics/saveCondition/saveCondition';
import { postSearchConditions } from '@doda/common/src/services/conditionRegistAPI';
import { AxiosError } from 'axios';
import {
  convertSavedSearchConditionsToQueryParams,
  selectSearchCondition,
} from 'logics/selectOverwriteCondition';

/**
 * 現在の検索条件を保存する関数
 *
 * @param {Object} params - パラメータのオブジェクト
 * @param {Omit<SavedSearchRequest, 'name'>} params.conditions - 保存する検索条件
 * @param {boolean} params.isLogin - ログイン状態
 * @param {string} [params.oldAction] - 以前のアクション
 * @param {string} [params.conditionName] - 検索条件の名前
 * @param {number} params.savedSearchCount - 保存された検索件数
 * @returns {Promise<void>} - 非同期処理を示すプロミス
 */
export const saveCurrentCondition = async ({
  conditions,
  isLogin,
  oldAction,
  conditionName,
  savedSearchCount,
}: {
  conditions: Omit<SavedSearchRequest, 'name'>;
  isLogin: boolean;
  oldAction?: string;
  conditionName?: string;
  savedSearchCount: number;
}) => {
  const searchConditionName = conditionName ?? createSearchConditionName();
  if (isLogin) {
    // ログイン状態の場合
    try {
      await apiClient.api.v1.savedSearches.post({
        body: { ...conditions, name: searchConditionName },
      });
      const mpscDtno = savedSearchCount + 1;
      // 保存に成功した場合は、おすすめ一覧に遷移
      window.location.href = `${DODA_SITE_URL.recommendJobList}/?mpsc_dtno=${mpscDtno}`;
    } catch (error) {
      const axiosError = error as AxiosError;
      // 保存件数が5件以上の場合は、上書き条件を選択する画面に遷移
      if (Number(axiosError.response?.status) === 400) {
        selectSearchCondition({
          conditions,
          action: oldAction,
          conditionName: searchConditionName,
        });
      }

      if (Number(axiosError.response?.status) > 400) {
        window.DD_LOGS?.logger.error(
          `【検索条件保存失敗】 conditions:${conditions} action:${oldAction} status:${axiosError.response?.status}`
        );
      }
    }
  } else {
    // 未ログイン状態の場合
    const url = '/dcfront/login/login/';
    const param = {
      action: oldAction ?? '',
      oldestDayWdtno: 0,
      SP_CC_wsernm: searchConditionName,
    };
    // 検索条件保存リクエストパラメータから対応するクエリパラメータに変換
    const newConditions = convertSavedSearchConditionsToQueryParams(conditions);
    const sendCondition = makeSendConditionParam(newConditions);
    const newParam = {
      tp: '1',
      ...TEMPLATE_CONDITION,
      ...param,
      ...sendCondition,
    };
    postSearchConditions(url, newParam, {});
  }
};
